import { Box, Stack, Td, Text, Th, Tr } from '@chakra-ui/react';
import { useAuth, usePagination } from 'core';
import { useFetchBoardProjectPageQuery } from '../../api';
import { BoardProjectLink, CurrencyLabel } from '../components';
import { AppTable } from '../table';

export interface BoardProjectSearchPageProps {}

export const BoardProjectSearchPage = (props: BoardProjectSearchPageProps) => {
  const auth = useAuth();
  const [page, setPagination] = usePagination();
  const { data: bpPage } = useFetchBoardProjectPageQuery(
    {
      ...page,
      clientId: auth?.user.clientId || "0",
    },
    { skip: !auth?.user.clientId }
  );

  let tableBody = (
    <>
      <Tr>
        <Td colSpan={2}>Loading...</Td>
      </Tr>
    </>
  );

  if (bpPage) {
    tableBody = (
      <>
        {bpPage.items.map((bp) => (
          <Tr>
            <Td>
              <BoardProjectLink bp={bp} />
            </Td>
            <Td>{bp.description}</Td>
            <Td>
              <CurrencyLabel value={bp.boardApproval} />
            </Td>
            <Td>{bp.allocatedPercent} %</Td>
            <Td>
              <CurrencyLabel value={bp.allocatedBoardApproval} />
            </Td>
            <Td>
              {/* <CurrencyLabel value={bp.budgeted} /> */}
              <Text>N/A</Text>
            </Td>
            <Td>
              {/* <CurrencyLabel value={bp.contingency} /> */}
              <Text>N/A</Text>
            </Td>
          </Tr>
        ))}
      </>
    );
  }

  return (
    <Box>
      <Stack>
        <AppTable
          title="Search Board Projects"
          body={tableBody}
          header={
            <>
              <Tr>
                <Th>Name</Th>
                <Th>Description</Th>
                <Th>Board Approval</Th>
                <Th>Allocated %</Th>
                <Th>Allocated $</Th>
                <Th>Budgeted</Th>
                <Th>Contingency</Th>
              </Tr>
            </>
          }
          pagination={{
            ...page,
            itemCount: Number(bpPage?.itemCount ?? 0),
            pageCount: Number(bpPage?.pageCount ?? 0),
          }}
          onPaginationChange={setPagination}
        ></AppTable>
      </Stack>
    </Box>
  );
};
